//Script for clicable rows in Ublaboo tables
$(document).ready(function () {
    $(document).on("click", ".clickable", function (event) {
        event.preventDefault();
        var elem = $(this).parent();
        var too = elem.attr('"data-click-to"');
        if (too != undefined) {
            location.href = too;
        }
    });
});